import React, { useEffect, useState } from "react";
import Service from "../Service/http";
import Util from "../Service/util";
import { useParams } from "react-router-dom";
import TimeAgo from 'react-timeago';
import { toast } from "react-toastify";
import ProfileImage from './ProfileImage/ProfileImage';
import ProfileTabs from "./ProfileTabs";
import ProfileCard from "./Profilecards/ProfileCard";
import { Tooltip, Typography } from "@mui/material";
import Loader from "../Admin/Loader/Loader";

function Main() {

    const [crawlerApproved, setCrawlerApproved] = useState(false);
    const [forceCrawl, setForceCrawl] = useState(false)
    const [percent, setPercent] = useState(0)
    const [loading, setLoading] = useState(false);
    const { id } = useParams();
    const [profileData, setProfileData] = useState({});
    const [statsData, setStatsData] = useState({});
    const [validationData, setValidationData] = useState([])

    const profileSections = [
        { value: 'two', label: 'Coding Profile', path: `/coding/profile/${id}` },
        { value: 'one', label: 'Profile Page', path: `/profile/${id}` },
    ];

    let service = new Service();
    let util = new Util();

    const HandleForceCrawl = () => {
        const user = util.getUserDetails();
        service.put('api/user/clear/lastcrawltime', 
        {user_id:id}
        )
        .then((res)=>{
          if(res.data==="success"){
            toast.success("The score will be updated in " + (Math.round(res.time * 60)) + " minutes");
            setForceCrawl(false);
          }
          else{
            toast.error(res.message);
          }
        })
        .catch((err)=>{
          toast.error(err);
        })
      }

    useEffect(() => {
        setLoading(true)
        service
            .get("api/profile/user/" + id)
            .then((json) => {
                setProfileData(json?.userData);
                setCrawlerApproved(json?.userData?.is_crawling_approved)
                setStatsData(json.data)
            })
            .catch((error) => {
                console.error(error);
            }).finally(() => setLoading(false));
    }, []);

    useEffect(()=>{
    
        let id ;  //let it be undefined to get current user data
        service
        .get("api/profile/coding/"+id)
        .then((json) => {
            setValidationData(json)
            if(json.is_crawling_approved){
                if(json.user_last_force_crawled_at){
                    let last_crawled_at = new Date(json.user_last_force_crawled_at);
                    let curr_time = new Date();
                    let diff = curr_time.getTime() - last_crawled_at.getTime();
                    const student_force_crawl_interval_in_hours = json.student_force_crawl_interval_in_hours || 24;
                    if(diff >= (student_force_crawl_interval_in_hours*60*60*1000)){
                        setForceCrawl(true);
                    }
                    else {
                        setForceCrawl(false);
                    }
                }
            else{
                setForceCrawl(true);
            }
        }
             let len = 0;
             let defaultValues = {
                "batch": "OTH",
                "tshirt_size": "OTH",
                "college": "OTH",
                "department" : "OTH",
             }
             // Update this array when ever you add a new field to the api;
             let skipValues = ["batches", "name", "phase", "site_count", "student_force_crawl_interval_in_hours", "tags", "user_id", "is_crawling_approved", "user_last_force_crawled_at"]
             for( let ele in json){
               if( !ele.includes("valid") && !skipValues.includes(ele) && !json.site_count.includes(ele.toUpperCase()) ){
                 if(!(defaultValues[ele] && defaultValues[ele]===json[ele])){
                    len++;
                }
              }
               else if (ele.includes("valid")) {
                 if(json[ele] === true && ele.length > 5 && json[ele.substring(0, ele.length - 6)]){
                  len++;
                 }
               }
             }
             let site_details_count=json.site_count.length;
             let student_details_count= 11;
             setPercent( Math.round( (len/(student_details_count+site_details_count))*100 ) ) ;
        })
        .catch((error) => {
            console.log(error);
        });
      },[])

    return (
        <>
            { !loading ?
                <div className="container-fluid" style={{minHeight: '100vh', borderRadius: 20, backgroundColor: '#e3e3e3', width: '97vw'}}>
                <div className="text-center h5 font-monospace text-primary mt-2 mb-2" style={{ display: "flex", justifyContent: "space-between" }}>
                    <ProfileTabs profileSections={profileSections} />
                </div>
                <div class="row h-100">
                    <div class="col-12 d-flex flex-column h-100">
                        <div class="flex-grow-1 position-relative d-flex flex-column align-items-end bg-light" style={{height: '220px', borderRadius: 20}}>
                            <div className="d-flex align-items-center justify-content-center w-100" style={{height: 40}}>
                            <Tooltip title={`${percent}% profile completed`} placement="right-start" arrow>
                                <div className="progress w-75" style={{borderRadius: 10, cursor: 'pointer'}}>
                                    <div className="progress-bar progress-bar-striped bg-primary h-100" role="progressbar" style={{"width": `${percent}%`, height: 15, borderRadius: 10}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>
                            </Tooltip>
                            </div>
                            <div className="beingzero-watermark text-end" style={{fontWeight: 'bold', letterSpacing: 20, top: 60, fontSize: '30px', color: 'lightgray'}}>
                                BEING ZERO
                            </div>
                            <div className="position-absolute profile-image-circle-container" style={{bottom: -50, left : 40}}>
                                <ProfileImage profileData={profileData}/>
                            </div>
                            <div className="h-100 d-flex flex-row-reverse flex-md-row" style={{width: '80%'}}>
                                <div className="w-100 d-flex flex-column align-items-end align-items-md-start justify-content-end p-3 profile-container">
                                    <h4 className="text-primary">{profileData?.name?.toUpperCase()}</h4>
                                    <span className="text-primary email-span" style={{width: '70%', wordWrap: 'break-word'}}>{profileData.email}</span>
                                    <span className="text-primary email-span" style={{width: '70%', wordWrap: 'break-word'}}>{profileData.roll_number}</span>
                                    <h4 className={`${crawlerApproved ? 'text-success': 'text-danger'} mt-1`}>
                                        {crawlerApproved ? 'Approved' : 'Not Approved'}
                                    </h4>
                                </div>
                            </div>
                        </div>
                        <div class="flex-grow-3 mt-3 p-3 bg-light d-flex justify-content-center align-items-center flex-column" style={{borderRadius: 20}}>
                            
                            <div className="user-info d-flex justify-content-center border w-100 flex-column bg-secondary mb-3" style={{borderRadius: 20}}>
                                <div className="w-100 d-flex justify-content-center">
                                    {profileData?.college && <span className="text-secondary" style={{whiteSpace: 'normal', padding: 7, fontFamily: 'serif', fontWeight: 'bold'}}>College : {profileData?.college}</span>}
                                </div>
                                <p className="text-center bg-light mx-2" style={{borderRadius: 10, fontWeight: 'lighter'}}>Last Crawled At: <TimeAgo date={new Date(profileData?.user_last_crawled_at)} /></p>
                                <div className="badge-group d-flex flex-wrap justify-content-center my-2">
                                    {
                                        (profileData?.batches && profileData?.batches?.length) ? profileData?.batches?.map((batch) => {
                                            return <span className="badge bg-primary m-1"> {batch}</span>
                                        }) : <span className="badge bg-light text-danger m-1 w-50 p-2">NOT A PART OF ANY BATCH</span>
                                    }
                                </div>
                            </div>
                            <div className="d-flex justify-content-end w-100 m-2">
                                <h3 className="text-center w-75" style={{fontWeight: 'bold', color: '#b1b0b0'}}>CODING PROFILES</h3>
                                <Tooltip title={<Typography>{crawlerApproved ? "You can only Force Update once every 24 hours" : "You are not approved"}</Typography>} placement="left" arrow>
                                    <button className="custom-button" style={{backgroundColor: forceCrawl ? '#295674' : 'gray'}} onClick={HandleForceCrawl} disabled={!forceCrawl}>Force Update Score</button>
                                </Tooltip>
                            </div>
                            <div
                                className="mt-2 px-3 py-2"
                                style={{
                                    color: 'gray',
                                    fontSize: '1.1rem',
                                    textAlign: 'left',
                                    marginLeft: '-10px', 
                                }}
                                >
                                <span style={{ color: 'red', marginRight: '5px' }}>*</span>
                                <span>
                                    <strong>Note:</strong> Participation in global contests is considered only if at least one successful submission has been made during the contest.
                                </span>
                                </div>

                            <div className="cards-box d-flex justify-content-center align-items-center bg-secondary flex-wrap m-2" style={{width: '100%', padding: '10px 0px', borderRadius: 10}}>

                                <ProfileCard userData={statsData['MENTORPICK']} siteName={'MENTORPICK'} valid={validationData?.mentorpick_valid} />
                                <ProfileCard userData={statsData['CODEFORCES']} siteName={'CODEFORCES'} valid={validationData?.codeforces_valid}/>
                                <ProfileCard userData={statsData['CODECHEF']} siteName={'CODECHEF'} valid={validationData?.codechef_valid}/>
                                <ProfileCard userData={statsData['LEETCODE']} siteName={'LEETCODE'} valid={validationData?.leetcode_valid}/>
                                {/* <ProfileCard userData={statsData['HACKERRANK']} siteName={'HACKERRANK'} valid={validationData?.hackerrank_valid} /> */}
                                
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div> : <Loader/>
        }   
    </>
    );
}

export default Main;